import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'directories.filters-v2.main.flags.copy.error.title',
		defaultMessage: "We couldn't create {name}",
		description:
			'Title of the flag shown in Filters Directory when the request for creating a copy of the existing filter failed',
	},
	description: {
		id: 'directories.filters-v2.main.flags.copy.error.description',
		defaultMessage: 'There was an error, please try again.',
		description:
			'Message shown in the flag displayed in Filters Directory when the request for creating a copy of the existing filter failed',
	},
});

const copyError = (name: string): FlagConfiguration => ({
	type: 'error',
	title: [messages.title, { name }],
	description: messages.description,
	messageId: 'filters-main.flags.copy.flag.error',
	messageType: 'transactional',
});

export default copyError;
